module.exports = __webpack_public_path__ + "img/rocket.6e3e5a38.svg";